import { Outlet } from "@tanstack/react-router";
import { useTheme } from "@/hooks/useTheme";
import Header from "./Header";
import Footer from "./Footer";

export default function PageLayout() {
  useTheme();

  return (
    <div className="flex min-h-screen flex-col bg-background">
      <Header />
      <main className="relative z-10 flex-1">
        <div className="container-responsive">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
